import React from "react";
import styled from "styled-components";
import { object as obj, arrayOf, func } from "prop-types";

import CarerCard from "components/postcode_search/CarerCard";

const StyledResults = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  max-width: 1155px;
  margin: 30px auto;
  -webkit-mask-image: linear-gradient(rgba(0, 0, 0, 1) 75%, transparent);
`;

function PostCodeSearchResults({ carers, taxonomies, onClick }) {
  return (
    <StyledResults data-testid="postcode-search-results">
      {carers.map(carer => (
        <CarerCard
          carer={carer}
          onClick={onClick}
          taxonomies={taxonomies}
          key={carer.profile.id}
        />
      ))}
    </StyledResults>
  );
}

PostCodeSearchResults.propTypes = {
  carers: arrayOf(obj).isRequired,
  taxonomies: obj.isRequired,
  onClick: func.isRequired
};

export default PostCodeSearchResults;
